import React, { useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { API_BASE } from '../../context/Functionality';

export default function EmailVerification() {
  const [token] = useState(() => new URLSearchParams(window.location.hash.slice(1)).get('token') || '');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const [complete, setComplete] = useState(false);
  async function submit(event) {
    event.preventDefault();
    setError(''); setMessage('');
    if (token && password !== confirmation) { setError('Your passwords do not match.'); return; }
    setBusy(true);
    try {
      const { data } = await axios.post(`${API_BASE}/auth/${token ? 'verify-email' : 'resend-verification'}`, token ? { token, password } : { email });
      setMessage(data.message);
      if (token) {
        setComplete(true); setPassword(''); setConfirmation('');
        localStorage.removeItem('token'); localStorage.removeItem('user');
        window.history.replaceState(null, '', window.location.pathname);
      }
    } catch (err) { setError(err.response?.data?.errMsg || 'Unable to reach the server. Please try again.'); }
    finally { setBusy(false); }
  }
  return <section className="min-h-screen flex items-center justify-center px-5">
    <div className="bg-gray-100 rounded-2xl shadow-lg w-full max-w-md p-8 text-[#002D74]">
      <h1 className="font-bold text-2xl">Verify your email</h1>
      <p className="my-4">{token ? 'Choose your account password to confirm your email and activate your portal.' : 'Check your inbox for a verification link. Enter your email below if you need another link.'}</p>
      {message && <p role="status" className="my-4">{message}</p>}
      {error && <p role="alert" className="my-4 text-red-700">{error}</p>}
      {!complete && <form onSubmit={submit} className="flex flex-col gap-4">
        {token ? <>
          <label htmlFor="verify-password">Account password (at least 12 characters)</label>
          <input id="verify-password" className="p-3 border rounded-xl" type="password" autoComplete="new-password" minLength={12} required value={password} onChange={e => setPassword(e.target.value)} />
          <label htmlFor="verify-confirmation">Confirm password</label>
          <input id="verify-confirmation" className="p-3 border rounded-xl" type="password" autoComplete="new-password" minLength={12} required value={confirmation} onChange={e => setConfirmation(e.target.value)} />
        </> : <>
          <label htmlFor="verification-email">Email address</label>
          <input id="verification-email" className="p-3 border rounded-xl" type="email" autoComplete="email" required maxLength={254} value={email} onChange={e => setEmail(e.target.value)} />
        </>}
        <button disabled={busy} className="bg-[#002D74] text-white rounded-xl py-3 disabled:opacity-50">{busy ? 'Please wait…' : token ? 'Verify email and activate account' : 'Send verification link'}</button>
      </form>}
      {token && !complete && <a className="block mt-4 underline" href="/verify-email">Request a new verification link</a>}
      <a className="block mt-4 underline" href="/login">Back to login</a>
      {!token && <Link className="block mt-4 underline" to="/register">Create an account</Link>}
    </div>
  </section>;
}
